module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showContent) ? _c('div', {
    staticClass: "swrapper",
    class: _vm.wrapperClass
  }, [_vm._t("before"), _vm._t("default")], 2) : _c('Spinner', {
    class: _vm.wrapperClass,
    attrs: {
      "size": _vm.size,
      "height": _vm.height
    }
  }, [_vm._t("before")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c64c9c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spinners/swrapper/Swrapper.vue
// module id = 547d1c2da3f9bd5e7322
// module chunks = 89